<!--
 * @Description:
 * @Author: 王赵坤
 * @Date: 2022-10-27 11:07:24
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-01-06 17:00:48
 * @FilePath: \VUE3\src\pages\jiaowu\views\pkgl\paikerenwu\xiaolijiaoshikebiao.vue
-->
<template>
  <el-table :data="tableData" :span-method="dSpanCellMerge" border style="width: 100%;">
    <el-table-column label="时段" align="center" width="46px">
      <template #default="scope">
        <p style="writing-mode: tb-rl;" v-if="scope.row.sd==1">上 午</p>
        <p style="writing-mode: tb-rl;" v-if="scope.row.sd==2">下 午</p>
        <p style="writing-mode: tb-rl;" v-if="scope.row.sd==3">晚 上</p>
      </template>
    </el-table-column>
    <el-table-column prop="amount1" label="节次" align="center" width="80px">
      <template #default="scope">
        <span>第{{scope.row.xq1.jc}}节</span>
      </template>
    </el-table-column>
    <el-table-column prop="kssj" label="上课时间" align="center" width="90px">
      <template #default="scope">
        <span>{{scope.row.kssj}}</span>-<span>{{scope.row.jssj}}</span>
      </template>
    </el-table-column>
    <el-table-column align="center">
      <template v-slot:header>
            <div>星期一</div>
            <div>{{jtsjfirm.sj1}}</div>
      </template>
      <template #default="scope">
        <!-- v-for="(elem) in scope.row.xq7.kclist" :key="elem.id" -->
        <div class="divspanlv" @click="chuanshujv(scope.row.xq1,jtsjfirm.sj1)">
          <span v-show="scope.row.xq1.sklx==2&&scope.row.xq1.cbkbs">{{scope.row.xq1.kcmc}}({{scope.row.xq1.cbmc}})</span>
          <!--<span v-show="scope.row.xq1.sklx==1">{{scope.row.xq1.kcmc}}(合)</span> -->
          <span v-show="scope.row.xq1.sklx==0">{{scope.row.xq1.kcmc}}</span>
          <div>
            <span v-show="scope.row.xq1.kclb==1">理论</span>
            <span v-show="scope.row.xq1.kclb==2">实践</span>
          </div>
          <span>{{scope.row.xq1.jsxm}}</span>
          <span>{{scope.row.xq1.bjmc}}</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column align="center">
      <template v-slot:header>
            <div>星期二</div>
            <div>{{jtsjfirm.sj2}}</div>
      </template>
      <template #default="scope">
        <!-- v-for="(elem) in scope.row.xq7.kclist" :key="elem.id" -->
        <div class="divspanlv" @click="chuanshujv(scope.row.xq2,jtsjfirm.sj2)">
          <span v-show="scope.row.xq2.sklx==2&&scope.row.xq2.cbkbs">{{scope.row.xq2.kcmc}}({{scope.row.xq2.cbmc}})</span>
          <!-- <span v-show="scope.row.xq2.sklx==2">{{scope.row.xq2.kcmc}}(拆)</span>
                                <span v-show="scope.row.xq2.sklx==1">{{scope.row.xq2.kcmc}}(合)</span> -->
          <span v-show="scope.row.xq2.sklx==0">{{scope.row.xq2.kcmc}}</span>
          <div>
            <span v-show="scope.row.xq2.kclb==1">理论</span>
            <span v-show="scope.row.xq2.kclb==2">实践</span>
          </div>
          <span>{{scope.row.xq2.jsxm}}</span>
          <span>{{scope.row.xq2.bjmc}}</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column align="center">
      <template v-slot:header>
            <div>星期三</div>
            <div>{{jtsjfirm.sj3}}</div>
      </template>
      <template #default="scope">
        <!-- v-for="(elem) in scope.row.xq7.kclist" :key="elem.id" -->
        <div class="divspanlv" @click="chuanshujv(scope.row.xq3,jtsjfirm.sj3)">
          <!-- <span v-show="scope.row.xq3.sklx==2">{{scope.row.xq3.kcmc}}(拆)</span>
                                <span v-show="scope.row.xq3.sklx==1">{{scope.row.xq3.kcmc}}(合)</span> -->
          <span v-show="scope.row.xq3.sklx==2&&scope.row.xq3.cbkbs">{{scope.row.xq3.kcmc}}({{scope.row.xq3.cbmc}})</span>
          <span v-show="scope.row.xq3.sklx==0">{{scope.row.xq3.kcmc}}</span>
          <div>
            <span v-show="scope.row.xq3.kclb==1">理论</span>
            <span v-show="scope.row.xq3.kclb==2">实践</span>
          </div>
          <span>{{scope.row.xq3.jsxm}}</span>
          <span>{{scope.row.xq3.bjmc}}</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column align="center">
      <template v-slot:header>
            <div>星期四</div>
            <div>{{jtsjfirm.sj4}}</div>
      </template>
      <template #default="scope">
        <!-- v-for="(elem) in scope.row.xq7.kclist" :key="elem.id" -->
        <div class="divspanlv" @click="chuanshujv(scope.row.xq4,jtsjfirm.sj4)">
          <span v-show="scope.row.xq4.sklx==2&&scope.row.xq4.cbkbs">{{scope.row.xq4.kcmc}}({{scope.row.xq4.cbmc}})</span>
          <!-- <span v-show="scope.row.xq4.sklx==2">{{scope.row.xq4.kcmc}}(拆)</span>
                                <span v-show="scope.row.xq4.sklx==1">{{scope.row.xq4.kcmc}}(合)</span> -->
          <span v-show="scope.row.xq4.sklx==0">{{scope.row.xq4.kcmc}}</span>
          <div>
            <span v-show="scope.row.xq4.kclb==1">理论</span>
            <span v-show="scope.row.xq4.kclb==2">实践</span>
          </div>
          <span>{{scope.row.xq4.jsxm}}</span>
          <span>{{scope.row.xq4.bjmc}}</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column align="center">
      <template v-slot:header>
            <div>星期五</div>
            <div>{{jtsjfirm.sj5}}</div>
      </template>
      <template #default="scope">
        <!-- v-for="(elem) in scope.row.xq7.kclist" :key="elem.id" -->
        <div class="divspanlv" @click="chuanshujv(scope.row.xq5,jtsjfirm.sj5)">
          <span v-show="scope.row.xq5.sklx==2&&scope.row.xq5.cbkbs">{{scope.row.xq5.kcmc}}({{scope.row.xq5.cbmc}})</span>
          <!-- <span v-show="scope.row.xq5.sklx==2">{{scope.row.xq5.kcmc}}(拆)</span>
                                <span v-show="scope.row.xq5.sklx==1">{{scope.row.xq5.kcmc}}(合)</span> -->
          <span v-show="scope.row.xq5.sklx==0">{{scope.row.xq5.kcmc}}</span>
          <div>
            <span v-show="scope.row.xq5.kclb==1">理论</span>
            <span v-show="scope.row.xq5.kclb==2">实践</span>
          </div>
          <span>{{scope.row.xq5.jsxm}}</span>
          <span>{{scope.row.xq5.bjmc}}</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column align="center">
      <template v-slot:header>
            <div>星期六</div>
            <div>{{jtsjfirm.sj6}}</div>
      </template>
      <template #default="scope">
        <!-- v-for="(elem) in scope.row.xq7.kclist" :key="elem.id" -->
        <div class="divspanlv" @click="chuanshujv(scope.row.xq6,jtsjfirm.sj6)">
          <span v-show="scope.row.xq6.sklx==2&&scope.row.xq6.cbkbs">{{scope.row.xq6.kcmc}}({{scope.row.xq6.cbmc}})</span>
          <!-- <span v-show="scope.row.xq6.sklx==2">{{scope.row.xq6.kcmc}}(拆)</span>
                                <span v-show="scope.row.xq6.sklx==1">{{scope.row.xq6.kcmc}}(合)</span> -->
          <span v-show="scope.row.xq6.sklx==0">{{scope.row.xq6.kcmc}}</span>
          <div>
            <span v-show="scope.row.xq6.kclb==1">理论</span>
            <span v-show="scope.row.xq6.kclb==2">实践</span>
          </div>
          <span>{{scope.row.xq6.jsxm}}</span>
          <span>{{scope.row.xq6.bjmc}}</span>
        </div>
      </template>
    </el-table-column>
    <el-table-column align="center">
      <template v-slot:header>
            <div>星期七</div>
            <div>{{jtsjfirm.sj7}}</div>
      </template>
      <template #default="scope">
        <!-- v-for="(elem) in scope.row.xq7.kclist" :key="elem.id" -->
        <div class="divspanlv" @click="chuanshujv(scope.row.xq7,jtsjfirm.sj7)">
          <span v-show="scope.row.xq7.sklx==2&&scope.row.xq7.cbkbs">{{scope.row.xq7.kcmc}}({{scope.row.xq7.cbmc}})</span>
          <!-- <span v-show="scope.row.xq7.sklx==2">{{scope.row.xq7.kcmc}}(拆)</span>
                                <span v-show="scope.row.xq7.sklx==1">{{scope.row.xq7.kcmc}}(合)</span> -->
          <span v-show="scope.row.xq7.sklx==0">{{scope.row.xq7.kcmc}}</span>
          <div>
            <span v-show="scope.row.xq7.kclb==1">理论</span>
            <span v-show="scope.row.xq7.kclb==2">实践</span>
          </div>
          <span>{{scope.row.xq7.jsxm}}</span>
          <span>{{scope.row.xq7.bjmc}}</span>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common'
const props = defineProps({
  jslistdata: {
    type: Array,
    required: true
  },
  xqid: {
    type: String,
    required: true
  },
  zcid: {
    type: String,
    required: true
  }
})
const zcid = ref('') // 周次
const xqid = ref('') // 学期id
const tableData = ref() // 课表结构
const merge = ref() // 存放需要合并的行
const pos = ref() // 需要合并行下标
const jiaoshilistdata = ref()
const emits = defineEmits(['chuanshujvxl'])
const jtsjfirm = ref({
  sj1: '',
  sj2: '',
  sj3: '',
  sj4: '',
  sj5: '',
  sj6: '',
  sj7: ''
})
// 传数据
const chuanshujv = (val, time) => {
  emits('chuanshujvxl', val, time)
}
// 教师结构
const getkebiaojiegou = () => {
  actionPost({
    url: '/api/v2/jiaowu/jiaowukebiaojiegou/list',
    data: {}
  }).then((res) => {
    res.data.xqRow.forEach((element) => {
      if (jiaoshilistdata.value) {
        jiaoshilistdata.value.forEach((item) => {
          if (item.xq === 1) {
            if (element.xq1.jc === item.jc) {
              element.xq1 = item
            }
          }
          if (item.xq === 2) {
            if (element.xq2.jc === item.jc) {
              element.xq2 = item
            }
          }
          if (item.xq === 3) {
            if (element.xq3.jc === item.jc) {
              element.xq3 = item
            }
          }
          if (item.xq === 4) {
            if (element.xq4.jc === item.jc) {
              element.xq4 = item
            }
          }
          if (item.xq === 5) {
            if (element.xq5.jc === item.jc) {
              element.xq5 = item
            }
          }
          if (item.xq === 6) {
            if (element.xq6.jc === item.jc) {
              element.xq6 = item
            }
          }
          if (item.xq === 7) {
            if (element.xq7.jc === item.jc) {
              element.xq7 = item
            }
          }
        })
      }
    })
    tableData.value = res.data.xqRow
    //
    xvk(res.data.xqRow)
  })
}
// 周次具体日期
const getnianyve = () => {
  actionPost({
    url: '/api/v2/jiaowu/jiaowuxiaoli/zhouciriqi',
    data: {
      xqid: xqid.value,
      zc: zcid.value
    }
  }).then((res) => {
    res.data.forEach((sjdata) => {
      if (sjdata.xq === 1) {
        jtsjfirm.value.sj1 = sjdata.rq
      }
      if (sjdata.xq === 2) {
        jtsjfirm.value.sj2 = sjdata.rq
      }
      if (sjdata.xq === 3) {
        jtsjfirm.value.sj3 = sjdata.rq
      }
      if (sjdata.xq === 4) {
        jtsjfirm.value.sj4 = sjdata.rq
      }
      if (sjdata.xq === 5) {
        jtsjfirm.value.sj5 = sjdata.rq
      }
      if (sjdata.xq === 6) {
        jtsjfirm.value.sj6 = sjdata.rq
      }
      if (sjdata.xq === 7) {
        jtsjfirm.value.sj7 = sjdata.rq
      }
    })
    getkebiaojiegou()
  })
}
watch(
  () => props.jslistdata,
  () => {
    if (props.jslistdata) {
      jiaoshilistdata.value = props.jslistdata
      //
      getkebiaojiegou()
    }
  },
  { deep: true, immediate: true }
)
watch(
  () => props.xqid,
  () => {
    if (props.xqid) {
      xqid.value = props.xqid
      //
      getnianyve()
    }
  },
  { deep: true, immediate: true }
)
watch(
  () => props.zcid,
  () => {
    if (props.zcid) {
      zcid.value = props.zcid
      //
      getnianyve()
    }
  },
  { deep: true, immediate: true }
)
// 分析时段
const xvk = (data) => {
  merge.value = []
  for (let i = 0; i < data.length; i++) {
    if (i === 0) {
      merge.value.push(1)
      pos.value = 0
    } else {
      // 判断当前元素与上一个元素是否相同
      // 根据相同id进行合并,根据需要可进行修改
      if (data[i].sd === data[i - 1].sd) {
        merge.value[pos.value] += 1
        merge.value.push(0)
      } else {
        merge.value.push(1)
        pos.value = i
      }
    }
  }
}
const SpanCellMerge = ({ row, column, rowIndex, columnIndex }) => {
  if (columnIndex === 0) {
    const _row = merge.value[rowIndex]
    const _col = _row > 0 ? 1 : 0
    return {
      rowspan: _row,
      colspan: _col
    }
  }
}
const dSpanCellMerge = ({ row, column, rowIndex, columnIndex }) => {
  if (columnIndex === 0) {
    const _row = merge.value[rowIndex]
    const _col = _row > 0 ? 1 : 0
    return {
      rowspan: _row,
      colspan: _col
    }
  }
}
const sSpanCellMerge = ({ row, column, rowIndex, columnIndex }) => {
  if (columnIndex === 0) {
    const _row = merge.value[rowIndex]
    const _col = _row > 0 ? 1 : 0
    return {
      rowspan: _row,
      colspan: _col
    }
  }
}
getkebiaojiegou()
</script>
<style scoped lang="less">
.divspanlv {
  min-width: 100px;
  display: flex;
  flex-direction: column;
}
</style>
